<template>
  <div>
    <b-menu class="is-primary sticky-menu">
      <b-menu-list
        v-if="isUserLoggedIn()"
        class="is-primary"
      >
        <li
          v-for="(cat, catIndex) in catArray"
          :key="catIndex"
        >
          <a
            class="section-header"
            @click="toggleSection(cat.name)"
          >
            <b-icon
              :icon="cat.icon"
              size="is-small"
            />
            <span>{{ cat.label }}</span>
            <b-icon
              class="section-chevron"
              :icon="isSectionOpen(cat.name) ? 'menu-down' : 'menu-up'"
              size="is-small"
            />
          </a>
          <ul v-show="isSectionOpen(cat.name)">
            <div
              v-for="(item, index) in arrayData"
              :key="index"
            >
              <div
                v-if="item.cat == cat.name"
                @click="setSelectedTab(item.name)"
              >
                <b-menu-item
                  :icon="item.icon"
                  :tag="item.tag"
                  :to="item.path"
                  :label="item.label"
                  :class="selectedTab === 'Info' ? '' : selectedTab === item.name ? 'is-active' : ''"
                />
              </div>
            </div>
          </ul>
        </li>
      </b-menu-list>
    </b-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Parse from "parse/dist/parse.min";
import {
	CATEGORIES, NAV_ITEMS, ROUTE_TAB_MAP
} from "@/lib/config/Navigation";
// 2. vor schleife um die bestehnde drum herum mit extra kategorien in 2. array + kategorie tag um 1. array einfügen




const OPEN_SECTIONS_KEY = "sidebarOpenSections";

function loadOpenSections() {
	try {
		const raw = localStorage.getItem(OPEN_SECTIONS_KEY);
		if (raw) return JSON.parse(raw);
	}
	catch (e) {
		console.error(e);
	}
	return {};
}

export default {
	name: "SideBar",
	data() {
		return {
			catArray: CATEGORIES,
			arrayData: NAV_ITEMS,
			selectedTab: "",
			openSections: loadOpenSections(),
		};
	},
	computed: {
		...mapGetters({
			user: "getCurrentUser",
		}),
	},
	watch: {
		$route(to) {
			this.syncSelectedTab(to);
		}
	},
	async mounted() {
		if (this.$route.name != null) this.syncSelectedTab(this.$route);
		else this.$router.push('/');
	},
	methods: {
		isSectionOpen(name) {
			// Sections without a stored state default to collapsed.
			return this.openSections[name] === true;
		},
		toggleSection(name) {
			this.$set(this.openSections, name, !this.isSectionOpen(name));
			try {
				localStorage.setItem(
					OPEN_SECTIONS_KEY, JSON.stringify(this.openSections));
			}
			catch (e) {
				console.error(e);
			}
		},
		syncSelectedTab(route) {
			if (!route || !route.name) return;
			this.selectedTab = ROUTE_TAB_MAP[route.name] || route.name;
		},
		setSelectedTab: async function (selectedTab) {
			this.selectedTab = selectedTab;
		},
		isUserLoggedIn() {
			return Parse.User.current() !== null;
		},
	},
};
</script>

<style scoped>
.sticky-menu {
	position: sticky;
	top: 3.75rem;
	max-height: calc(100vh - 4.25rem);
	overflow-y: auto;
}

::v-deep .is-active {
	background-color: rgba(0, 0, 0, 0.8) !important;
	color: white !important;
}

::v-deep .is-active>a {
	color: white !important;
}

::v-deep .is-active>a:hover {
	color: black !important;
	background-color: whitesmoke;
	border-radius: 0 0 0 0;
}

::v-deep a.is-active {
	font-weight: bold;
	font-size: 1.25rem;
	padding: 0.9em 1em;
	border-radius: 0 6px 0 0;
}

::v-deep .menu-list>li {
	padding: 0.25em 0;
}

::v-deep .menu-list>li:not(:last-child) {
	border-bottom: 1px solid rgb(240, 240, 240);
}

::v-deep .menu-list>li>ul {
	border: none;
	margin: 0 0 0.5em 0;
}

.section-header {
	display: flex;
	align-items: center;
	gap: 0.5em;
	/* Match the look of the former disabled category items. */
	color: #7a7a7a;
	cursor: pointer;
}

.section-header:hover {
	background-color: transparent;
	color: #4a4a4a;
}

.section-chevron {
	margin-left: auto;
}
</style>